import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import * as Sentry from "@sentry/react";
import ReactTooltip from "react-tooltip";
import React, { useRef, useState, useEffect } from "react";
import InstrumentModal from "./components/InstrumentModal";
import AboutModal from "./components/AboutModal";
import WelcomeModal from "./components/WelcomeModal";
import { GameModal, JAM_LEVEL } from "./components/GameModal";
import InstrumentButtons from "./components/InstrumentButtons";
import { Card, ButtonGroup, Modal, Container, Row, Col, ModalBody } from "react-bootstrap";
import Instrument from "./components/Instrument";
import { Button, Grid } from "@mui/material";
import { FormLabel, Box, Tooltip, FormControl, FormControlLabel, Switch } from "@mui/material";
import KeyOf from "./components/KeyOf";
import PlayerComponent from "./components/PlayerComponent";
import { Transport, Player } from "tone";
import Sound from ".//mp3s/lead.mp3";
import PlayButtons from "./components/PlayButtons";
import Presets from "./components/Presets";
import Onboarding from "./components/Onboarding";
import { allPresets } from "./components/allPresets";
import { gamePresets } from "./components/allPresets";
// import { MusicVAE } from "@magenta/music";
import { Preset } from "./components/allPresets";
import { TbLetterF, TbLetterW, TbLetterE, TbLetterR, TbLetterS, TbLetterX, TbLetterC, TbLetterV, TbLetterD, TbLetterA, TbLetterJ, TbLetterK, TbLetterL } from 'react-icons/tb';
import Letter from "./components/Letter";
import Info from "./components/Info";
import { wtfKeys } from "./components/Onboarding";
import Quant from "./components/Quant";
import Bpm from "./components/Bpm";
import Piano from "./components/Piano";
import { Load, show, Loader } from "./components/Load";
import Interaction from "./components/Interaction";
import Recording from "./components/Recording";
import { logger } from './components/Logger';
import { TbLetterU, TbLetterI, TbLetterO, TbQuestionMark } from 'react-icons/tb';
import Drawer from '@mui/material/Drawer';
// import { useTimeout } from '@swyg/corre';
import './components/config';
import SideDrawer from "./components/SideDrawer";
import MainPageInteract from "./components/MainPageInteract";
import { Stack } from "@mui/system";
import SettingsIcon from '@mui/icons-material/Settings';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import {JAM_LEVEL} from './components/GameModal';
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'G-P12T86YF2Q'
}

TagManager.initialize(tagManagerArgs)


var player = new Player({
  url: Sound,
  loop: true,
  autostart: false,
  onload: () => {
    App.enable();
    // alert("-0");
  }
}).toDestination();

// const mvae = new mm.MusicVAE('https://storage.googleapis.com/magentadata/js/checkpoints/groovae/tap2drum_4bar');
// mvae.initialize();


export default function App() {
  const [keyOf, setKeyOf] = useState("C");
  const [scale, setScale] = useState("major");
  const [presetName, setPresetName] = useState("");
  const [lastPlayed, setLastPlayed] = useState(['', '', '', '']);
  const [presetModalJson, setPresetModalJson] = useState('');
  const [showPresetModal, setShowPresetModal] = useState(false);
  const [loadedRecording, setLoadedRecording] = useState(null);
  const [wtf, setWTF] = useState(111);
  const [quant, setQuant] = useState('disabled');
  const [bpm, setBpm] = useState('120');
  const [mp3Vol, setMp3Vol] = useState('-1');
  const [lastPlayedAny, setLastPlayedAny] = useState('');
  const [lastPlayedInstrument, setLastPlayedAnyInstrument] = useState('');
  const [lastPlayedNote, setLastPlayedNote] = useState({ note: "", instrumentNumber: 0, time: Date.now(), pitch: 0, playback: false });
  const [lastAction, setLastAction] = useState(null);
  const [withRelease, setWithRelease] = useState(true);
  const [allowRepeat, setAllowRepeat] = useState(true);
  const [randomFourth, setRandomFourth] = useState(false);
  // const [playDrums, setPlayDrums] = useState(false);
  const [showLog, setShowLog] = useState(false);
  const [connectMQTT, setConnectMQTT] = useState(false);
  const [temperature, setTemperature] = useState(1.2);
  const [playTrioBass, setPlayTrioBass] = useState(false);
  const [playTrioDrums, setPlayTrioDrums] = useState(false);
  const [rotatePresets, setRotatePresets] = useState(false);
  const [presetRotateDuration, setPresetRotateDuration] = useState(100);
  const [drumVolume, setDrumVolume] = useState(22);
  const [useMidi, setUseMidi] = useState(false);
  const [activePlayButtons, setActivePlayButtons] = React.useState(false);
  const [playerStatus, setPlayerStatus] = React.useState('STOPPED');
  const [showInstrumentModal, setShowInstrumentModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(true);
  const [showGameModal, setShowGameModal] = useState(false);
  const [showPlayButtons, setShowPlayButtons] = useState(false);
  const [mp3, set_mp3] = useState("/audio/lead.mp3");
  const [playRandomMovieSoundRegularly, setPlayRandomMovieSoundRegularly] = useState(false);
  const [playRandomSoundRegularly, setPlayRandomSoundRegularly] = useState(false);
  const [playRandomNatureSoundRegularly, setPlayRandomNatureSoundRegularly] = useState(false);
  const [tips, setTips] = useState(true);
  const [AIOnanism, setAIOnanism] = useState(false);
  // const [mobileOpen, setMobileOpen] = React.useState(false);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [jamming, setJamming] = React.useState(false);
  const [params, setParams] = React.useState([]);
  const [levelNum, setLevelNum] = useState(JAM_LEVEL + 1);
  const [chords, setChords] = useState([]);

  // playTrioBass, playTrioDrums, drumVolume, playRandomMovieSoundRegularly, playRandomSoundRegularly, playRandomNatureSoundRegularly

  const [bassInstrument, setBassInstrument] = React.useState(new Instrument(
    Object.keys(toneInstruments)[1],
    0,
    5,
    11,
    85
  ));

  const [allInstruments, setInstruments] = React.useState([new Instrument(
    Object.keys(toneInstruments)[0],
    0,
    5,
    11,
    85
  ), new Instrument(
    Object.keys(toneInstruments)[1],
    0,
    5,
    24,
    75
  ), new Instrument(
    Object.keys(toneInstruments)[2],
    0,
    5,
    20,
    80
  )
    , new Instrument(
      Object.keys(toneInstruments)[3],
      0,
      5,
      15,
      85
    )]);

  const [currentInstrument, setCurrentInstrument] = useState(allInstruments[0]);

  const mp3s = [
    { label: "Chill Out Dub | E min", value: "chilloutdubinE.mp3" },
    { label: "Green Eggs | F# min", value: "greeneggs.mp3" },
    { label: "Lead | G# min", value: "lead.mp3" },
    { label: "I have a dream | B min", value: "i_have_a_dream.mp3" },
    { label: "Guitar in D minor", value: "guitar_d_minor.mp3" },
    { label: "Rumi Poem | A maj", value: "rumi.mp3" },
    { label: "Rumsfeld Poem | A# min", value: "rumsfeld.mp3" },
    { label: "Alan Watts | E min", value: "aw.mp3" },
    { label: "Never Want to Go | C min", value: "nwg.mp3" },
    { label: "Clinton | F min", value: "bclinton.mp3" },
    { label: "Johnson - Laughing song | F# min", value: "laughingsong_george_johnson.mp3" },
    { label: "Om So Hum | C# maj", value: "om_so_hum.mp3" },
    { label: "Tibetan Morning Chant | C# min", value: "tibetan_morning_chant.mp3" },
    { label: "Floyd style | D min", value: "floyd.mp3" },
    { label: "Big Foot | E maj", value: "bigfoot.mp3" },
    { label: "Gregorian Chant | A min", value: "gregorianchant.mp3" },
  ];

  const playerRef = useRef(player);
  const notesForTrioRef = useRef([]);
  const drumifyStartTimeRef = useRef(Date.now());
  const playerDrums = useRef(new mm.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/sgm_plus'));
  const logValue = useRef('log value');
  const trioDrumRef = useRef(null);
  const trioBassRef = useRef(null);
  // const trioMelRef = useRef([]);
  const lastHumanPlayed = useRef(Date.now());
  const waitingForDrumify = useRef(false);
  const waitingForBassify = useRef(false);
  const pdref = useRef(null);
  const playTrioDrumsRef = useRef(true);
  const midiOffListRef = useRef([]);

  // return null if shouldn't bassify
  function getNoteSequenceForBassify() {
    var duration = 8000;
    var last_8_bars = getLastNotes(notesForTrioRef.current, duration);
    console.log("last 8 BARS BASSIFY");
    console.log(last_8_bars);
    if (last_8_bars.length == 0) {
      console.log('bassify last 8 bars 0');
      return null;
    }
    // wait for drums to exist
    if (trioDrumRef.current == null) {
      console.log('bassify triodrum null');
      return null;
    }
    var notes = last_8_bars.concat(trioDrumRef.current.notes);
    var mmObject = { notes: notes, totalTime: 8 };
    const quantizedNotes = mm.sequences.quantizeNoteSequence(mmObject, 4);
    var quantizedNotesjson = JSON.stringify(quantizedNotes);
    return quantizedNotesjson;
  }

  //***********************
  var nsb = '{"notes":[{"pitch":67,"instrument":0,"program":0,"quantizedStartStep":"4","quantizedEndStep":"12"},{"pitch":65,"instrument":0,"program":0,"quantizedStartStep":"12","quantizedEndStep":"20"},{"pitch":67,"instrument":0,"program":0,"quantizedStartStep":"20","quantizedEndStep":"28"},{"pitch":65,"instrument":0,"program":0,"quantizedStartStep":"28","quantizedEndStep":"32"},{"pitch":65,"instrument":0,"program":0,"quantizedStartStep":"48","quantizedEndStep":"50"},{"pitch":67,"instrument":0,"program":0,"quantizedStartStep":"50","quantizedEndStep":"52"},{"pitch":70,"instrument":0,"program":0,"quantizedStartStep":"52","quantizedEndStep":"56"},{"pitch":70,"instrument":0,"program":0,"quantizedStartStep":"56","quantizedEndStep":"64"},{"pitch":38,"instrument":2,"isDrum":true,"quantizedStartStep":"4","quantizedEndStep":"5"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"8","quantizedEndStep":"9"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"10","quantizedEndStep":"11"},{"pitch":38,"instrument":2,"isDrum":true,"quantizedStartStep":"12","quantizedEndStep":"13"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"16","quantizedEndStep":"17"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"20","quantizedEndStep":"21"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"24","quantizedEndStep":"25"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"28","quantizedEndStep":"29"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"30","quantizedEndStep":"31"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"32","quantizedEndStep":"33"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"36","quantizedEndStep":"37"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"40","quantizedEndStep":"41"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"44","quantizedEndStep":"45"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"48","quantizedEndStep":"49"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"52","quantizedEndStep":"53"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"56","quantizedEndStep":"57"},{"pitch":36,"instrument":2,"isDrum":true,"quantizedStartStep":"60","quantizedEndStep":"61"}],"quantizationInfo":{"stepsPerQuarter":4}}';
  async function bassifyOnServer() {
    if (waitingForBassify.current == true) {
      return;
    }
    // var quantizedNotesjson = nsb; //getNoteSequenceForBassify();
    var quantizedNotesjson = getNoteSequenceForBassify();
    if (quantizedNotesjson == null) {
      return;
    }
    console.log("bassify with " + quantizedNotesjson);

    waitingForBassify.current = true;
    const bassifyUrl = 'https://boiling-zealous-creature.glitch.me/bassify';
    fetch(bassifyUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: quantizedNotesjson
    }).then((response) => response.json()).then(ns => {
      waitingForBassify.current = false;
      console.log(ns);
      trioBassRef.current = getInstrumentSequence(ns[0], 1);
      console.log("BASS:");
      console.log(trioBassRef.current);
    });
  }

  //  var json_for_drumbot = '{"notes":[{"pitch":50,"velocity":40,"program":26,"startTime":0.8386666666666667,"endTime":1.0886666666666667},{"pitch":53,"velocity":40,"program":26,"startTime":1.3293333333333333,"endTime":1.5793333333333333},{"pitch":53,"velocity":40,"program":26,"startTime":1.5213333333333332,"endTime":1.7713333333333332},{"pitch":53,"velocity":40,"program":26,"startTime":1.7613333333333332,"endTime":2.011333333333333},{"pitch":55,"velocity":40,"program":26,"startTime":2.2626666666666666,"endTime":2.5126666666666666},{"pitch":57,"velocity":40,"program":26,"startTime":2.78,"endTime":3.03}],"tempos":[{"qpm":120}],"totalTime":4,"temperature":1}';
  async function drumifyOnServer() {
    if (Date.now() - lastHumanPlayed.current > 28000) {
      // last_8_bars.length < 1 && ! AIOnanism) {
      console.log("set drums to null");
      trioDrumRef.current = null;
      return;
    }
    var duration = 8000;
    var last_8_bars = getLastNotes(notesForTrioRef.current, duration);
    if (last_8_bars.length == 0) {
      return;
    }
    // if (waitingForDrumify.current) {
    //   return;
    // }
    const DEFAULT_QUARTERS_PER_MINUTE = 120.0;
    var mmObject = { notes: last_8_bars, totalTime: 8 };
    const quantizedNotes = mm.sequences.quantizeNoteSequence(mmObject, 4);
    var quantizedNotesjson = JSON.stringify(quantizedNotes);
    console.log("drumifying with " + quantizedNotesjson);
    const start = Date.now();
    //  fetch('https://tame-dune-statistic.glitch.me/dnb', {
    waitingForDrumify.current = true;
    const drumifyUrl = 'https://tame-dune-statistic.glitch.me/drumify';
    // const drumifyUrl = 'http://127.0.0.1:3001/drumify';
    fetch(drumifyUrl, {
      //  fetch('https://honeysuckle-ambiguous-earwig.glitch.me/drumify', {
      //  fetch('http://127.0.0.1:654/dnb', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: quantizedNotesjson
    }).then((response) => response.json()).then(drums => {
      waitingForDrumify.current = false;
      console.log(drums);
      trioDrumRef.current = getDrumSequence(drums); //getInstrumentSequence(drums,2);
      //  trioBassRef.current = getInstrumentSequence(drums,1);
      //  trioMelRef.current = getInstrumentSequence(drums,0);
      console.log("trioDrum:" + JSON.stringify(trioDrumRef.current.notes.length));
      //  console.log("trioMel:" + JSON.stringify(trioMelRef.current.notes.length));
      // playerDrums.current.loadSamples(drums);
      // playerDrums.start(drums);

      //  playSequence(bassInstrument, trioBassRef.current.notes, 11);
      if (Date.now() - lastHumanPlayed.current > 8000) {
        // play melody if human hasn't been hitting
        //  playSequence(allInstruments[0], trioMelRef.current.notes, 0);
      }
      var time = Date.now() - start;
      console.log('server did drums in ' + time + '(ms)');
      //  playerDrums.current.getAudioNodeOutput().volume.value = drumVolume;
      //  playerDrums.current.start(trioDrumRef.current);
      //  playerDrums.current.stop();
    });
  }
  /********************/


  // function useInterval(callback, delay) {
  //   const savedCallback = useRef();

  //   // Remember the latest callback.
  //   useEffect(() => {
  //     savedCallback.current = callback;
  //   }, [callback]);

  //   // Set up the interval.
  //   useEffect(() => {
  //     function tick() {
  //       savedCallback.current();
  //     }
  //     if (delay !== null) {
  //       let id = setInterval(tick, delay);
  //       return () => clearInterval(id);
  //     }
  //   }, [delay]);
  // }


  function performRotation() {
    if (rotatePresets) {
      // grab random preset diff from current
      var newPresetName = presetName;
      do {
        console.log(Object.keys(allPresets));
        var presetsLength = Object.keys(allPresets).length;
        var presetIndex = Math.floor(Math.random() * presetsLength);
        newPresetName = Object.keys(allPresets)[presetIndex];
      } while (newPresetName == presetName);
      setPreset(newPresetName);  // from useeffect?
      setTimeout(() =>
        performRotation(),
        presetRotateDuration * 1000);
    }
  }

  useEffect(() => {
    playTrioDrumsRef.current = playTrioDrums;
  }, [playTrioDrums]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setParams(params);
    if (params.midi) {
      console.log('setting midi ')
      setUseMidi(true);
    }

  }, []);

  useEffect(() => {
    if (rotatePresets) {
      performRotation();
    }
  }, [rotatePresets]);

  useEffect(() => {
    if (wtf == wtfKeys.indexOf("BPM_QUANT") || wtf == wtfKeys.indexOf("KEY_SCALE")) {
      //   setDrawerOpen(true);
      setSettingsOpen(true);
      console.log('show');
    }
  }, [wtf]);

  useEffect(() => {
    waitingForDrumify.current = false;
    waitingForBassify.current = false;
  }, [playTrioDrums, playTrioBass]);

  // ****MIDI
  const midiOutput = useRef(null);
  useEffect(() => {
    if (useMidi) {
      navigator.requestMIDIAccess().then(onMIDISuccess, onMIDIFailure);
    };
  }, [useMidi]);

  function onMIDISuccess(midiAccess) {
    log("MIDI ready!");
    midiOutput.current = midiAccess.outputs.values().next().value;
    if (!midiOutput.current)
      console.log("Uh oh! Couldn't get i/o ports.");
  }

  function onMIDIFailure(msg) {
    alert("Couldn't connect:" + msg);
    log("Failed to get MIDI access - " + msg);
  }

  function sendMidiMessageOn(note, channel, velocity) {
    console.log("note: " + note + " channel: " + channel);
    var actionAndChannel = 143 + channel;
    const msg = [actionAndChannel, note, velocity];
    console.log(msg);
    try {
      midiOutput.current.send(msg)
    } catch (e) {
      log("EGZEPTION" + e.message);
    }
  }

  function sendMidiMessageOff(note, channel, velocity) {
    console.log("**midi off  --- note: " + note + " channel: " + channel);
    var actionAndChannel = 128 + channel;
    const msg = [actionAndChannel, note, velocity];
    try {
      midiOutput.current.send(msg)
    } catch (e) {
      log("EGZEPTION" + e.message);
    }
  }

  // global MIDI
  useEffect(() => {
    global.config.midi = useMidi;
  }, [useMidi]);

  const getNoteObject = (lastPlayedAny) => {
    var noteObject = {};
    noteObject.endTime = Date.now() + 1000; // TODO instrument duration
    noteObject.startTime = Date.now();
    noteObject.pitch = lastPlayedAny;
    noteObject.program = 26;
    noteObject.velocity = 88;
    noteObject.instrument = 1;
    return noteObject;
  };

  function log(entry) {
    logValue.current = new Date(Date.now()).toTimeString() + " " + entry + "\n" + logValue.current;
    console.log(entry);
  }

  // *** midi
  useEffect(() => {
    if (useMidi) {
      var midiNote = Tone.Frequency(lastPlayedNote.note).toMidi();
      var velocity = Math.floor(Math.random() * 40) + 88;
      // var velocity = 127;
      sendMidiMessageOn(midiNote, lastPlayedNote.instrumentNumber + 1, velocity);
      console.log("send midi on for " + midiNote + " velocity:" + velocity);
      var millisDuration = 500 + 1500 * Math.random();
      if (lastPlayedNote.instrumentNumber < 4) {
        // hack bass ai in array?
        var rand = Math.random() + 0.5;
        millisDuration = 1000 * allInstruments[lastPlayedNote.instrumentNumber].noteDuration * rand;
        console.log("note duration: " + allInstruments[lastPlayedNote.instrumentNumber].noteDuration);
        // 500 + 1500 * Math.random();
      }
      console.log("midi note duration: " + millisDuration);
      midiOffListRef.current.push(lastPlayedNote);
      setTimeout(() => {
        console.log('off');
        removeNoteFromOffList(lastPlayedNote);
        if (!sameNoteInList(lastPlayedNote)) {
          sendMidiMessageOff(midiNote, lastPlayedNote.instrumentNumber, 127)
        }
      },
        millisDuration);
    }
  }, [lastPlayedNote]);

  function removeNoteFromOffList(note) {
    for (let i = 0; i < midiOffListRef.current.length; i++) {
      if (midiOffListRef.current[i] == note) { // Check if current element matches itemToDelete
        midiOffListRef.current.splice(i, 1); // Remove the element at index i from the array
        console.log("found note");
        console.log(note);
      }
    }
  }

  function sameNoteInList(note) {
    var otherSameNoteExists = false;
    for (let i = 0; i < midiOffListRef.current.length; i++) {
      if (midiOffListRef.current[i].note == note.note && midiOffListRef.current[i].instrument == note.instrument) {
        // otherSameNoteExists = true;
        return true;
      }
    }
    return otherSameNoteExists;
  }

  // *** add to notes for TRIO
  useEffect(() => {
    if (lastPlayedInstrument != 11) {
      notesForTrioRef.current.push(getNoteObject(lastPlayedAny));
    }
  }, [lastPlayedAny]);

  // *** Send to mqtt
  useEffect(() => {
    if (connectMQTT) {
      var message = lastPlayedInstrument + " " + Tone.Frequency(lastPlayedAny).toMidi();;
      send_message(message, 'played');
    }
  }, [lastPlayedAny]);



  var instArray = ['piano', 'bass-electric', "synthtom", "Kalimba", "harp", "marimba", 'guitar-acoustic', "duosynth2", "duosynth", "bass", 'bassoon', 'guitar-electric', 'cello', 'clarinet', 'contrabass', 'flute', 'trumpet', 'tuba', 'violin', 'laughnotes', 'harmonium', 'xylophone', 'organ', 'guitar-nylon', 'french-horn'];

  //TODO move into initialstate
  // var instrument0 = new Instrument(
  //   Object.keys(toneInstruments)[0],
  //   0,
  //   5,
  //   11,
  //   85
  // );
  // var instrument1 = new Instrument(
  //   Object.keys(toneInstruments)[1],
  //   0,
  //   5,
  //   24,
  //   75
  // );
  // var instrument2 = new Instrument(
  //   Object.keys(toneInstruments)[2],
  //   0,
  //   5,
  //   20,
  //   80
  // );
  // var instrument3 = new Instrument(
  //   Object.keys(toneInstruments)[3],
  //   0,
  //   5,
  //   15,
  //   85
  // );

  // const instruments = [instrument0, instrument1, instrument2, instrument3];

  useEffect(() => {
    if (playRandomMovieSoundRegularly) {
      var intervalTime = 8000 + 8000 * Math.random();
      console.log('interval time: ' + intervalTime);
      const interval = setInterval(() => {
        console.log('play randomly');
        playRandomSoundMovies();
      }, intervalTime);
      return () => clearInterval(interval);
    }
  }, [playRandomMovieSoundRegularly]);
  useEffect(() => {
    if (playRandomSoundRegularly) {
      var intervalTime = 8000 + 8000 * Math.random();
      console.log('interval time: ' + intervalTime);
      const interval = setInterval(() => {
        console.log('play randomly');
        playRandomSound();
      }, intervalTime);
      return () => clearInterval(interval);
    }
  }, [playRandomSoundRegularly]);
  useEffect(() => {
    if (playRandomNatureSoundRegularly) {
      var intervalTime = 8000 + 8000 * Math.random();
      console.log('interval time: ' + intervalTime);
      const interval = setInterval(() => {
        console.log('play randomly');
        playRandomSoundNature();
      }, intervalTime);
      return () => clearInterval(interval);
    }
  }, [playRandomNatureSoundRegularly]);


  useEffect(() => {
    const interval = setInterval(() => {
      // console.log("EFFECT TIME: " + new Date().getMinutes() + ":" + new Date().getSeconds());
      console.log('TRIO INTERVAL');
      if (playTrioDrums) {
        if (!pdref.current || !pdref.current.soundFont.initialized) {
          pdref.current = new mm.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/sgm_plus');
          pdref.current.soundFont.initialize();
          pdref.current.loadSamples({
            "tempos": [{ "qpm": 120 }], "notes": [{ "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "0", "quantizedEndStep": "1", "velocity": 127 },
            { "pitch": 38, "instrument": 2, "isDrum": true, "quantizedStartStep": "0", "quantizedEndStep": "1", "velocity": 127 },
            { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "2", "quantizedEndStep": "3", "velocity": 127 },
            { "pitch": 40, "instrument": 2, "isDrum": true, "quantizedStartStep": "3", "quantizedEndStep": "4", "velocity": 127 },
            { "pitch": 44, "instrument": 2, "isDrum": true, "quantizedStartStep": "4", "quantizedEndStep": "5", "velocity": 127 },
            { "pitch": 46, "instrument": 2, "isDrum": true, "quantizedStartStep": "4", "quantizedEndStep": "5", "velocity": 127 },
            { "pitch": 48, "instrument": 2, "isDrum": true, "quantizedStartStep": "6", "quantizedEndStep": "7", "velocity": 127 },
            { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "6", "quantizedEndStep": "7", "velocity": 127 },
            { "pitch": 50, "instrument": 2, "isDrum": true, "quantizedStartStep": "8", "quantizedEndStep": "9", "velocity": 127 },
            { "pitch": 52, "instrument": 2, "isDrum": true, "quantizedStartStep": "10", "quantizedEndStep": "11", "velocity": 127 },
            { "pitch": 51, "instrument": 2, "isDrum": true, "quantizedStartStep": "10", "quantizedEndStep": "11", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "12", "quantizedEndStep": "13", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "12", "quantizedEndStep": "13", "velocity": 127 }, { "pitch": 38, "instrument": 2, "isDrum": true, "quantizedStartStep": "14", "quantizedEndStep": "15", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "14", "quantizedEndStep": "15", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "16", "quantizedEndStep": "17", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "16", "quantizedEndStep": "17", "velocity": 127 }, { "pitch": 46, "instrument": 2, "isDrum": true, "quantizedStartStep": "18", "quantizedEndStep": "19", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "19", "quantizedEndStep": "20", "velocity": 127 }, { "pitch": 38, "instrument": 2, "isDrum": true, "quantizedStartStep": "20", "quantizedEndStep": "21", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "20", "quantizedEndStep": "21", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "22", "quantizedEndStep": "23", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "22", "quantizedEndStep": "23", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "24", "quantizedEndStep": "25", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "26", "quantizedEndStep": "27", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "26", "quantizedEndStep": "27", "velocity": 127 }, { "pitch": 38, "instrument": 2, "isDrum": true, "quantizedStartStep": "28", "quantizedEndStep": "29", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "32", "quantizedEndStep": "33", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "32", "quantizedEndStep": "33", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "35", "quantizedEndStep": "36", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "35", "quantizedEndStep": "36", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "38", "quantizedEndStep": "39", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "38", "quantizedEndStep": "39", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "40", "quantizedEndStep": "41", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "40", "quantizedEndStep": "41", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "44", "quantizedEndStep": "45", "velocity": 127 }, { "pitch": 49, "instrument": 2, "isDrum": true, "quantizedStartStep": "44", "quantizedEndStep": "45", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "48", "quantizedEndStep": "49", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "50", "quantizedEndStep": "51", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "51", "quantizedEndStep": "52", "velocity": 127 }, { "pitch": 38, "instrument": 2, "isDrum": true, "quantizedStartStep": "52", "quantizedEndStep": "53", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "54", "quantizedEndStep": "55", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "54", "quantizedEndStep": "55", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "56", "quantizedEndStep": "57", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "56", "quantizedEndStep": "57", "velocity": 127 }, { "pitch": 36, "instrument": 2, "isDrum": true, "quantizedStartStep": "58", "quantizedEndStep": "59", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "58", "quantizedEndStep": "59", "velocity": 127 }, { "pitch": 38, "instrument": 2, "isDrum": true, "quantizedStartStep": "60", "quantizedEndStep": "61", "velocity": 127 }, { "pitch": 42, "instrument": 2, "isDrum": true, "quantizedStartStep": "62", "quantizedEndStep": "63", "velocity": 127 }], "quantizationInfo": { "stepsPerQuarter": 4 }, "totalQuantizedSteps": "64"
          });
        }
        // get next notes
        // nextTrio();
        drumifyOnServer();
        if (playTrioBass) {
          bassifyOnServer();
        }
        if (playTrioDrums && trioDrumRef.current != null) {
          if (trioDrumRef.current.notes.length > 0) {
            // play drums
            // playerDrums.current.getAudioNodeOutput().volume.value = 1
            // console.log(trioDrumRef.current.getAudioNodeOutput().volume.value);
            trioDrumRef.current.notes.forEach(note => {
              note.velocity = 127;
            });
            // var DRUMS = {
            //   notes: trioDrumRef.current,
            //   quantizationInfo: {stepsPerQuarter: 4},
            //   tempos: [{time: 0, qpm: 120}],
            //   totalQuantizedSteps: 64
            // };
            console.log("DRUM length" + trioDrumRef.current.notes.length);
            console.log(JSON.stringify(trioDrumRef.current));
            console.log(trioDrumRef.current.notes.length);
            if (useMidi) {
              console.log("PLAY SEQUENCE");
              playDrumSequence(trioDrumRef.current);
            } else {
              console.log("play drums")
              // console.log(trioDrumRef.current);
              // var pd = new mm.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/sgm_plus');
              // pd.loadSamples(trioDrumRef.current);
              playSFDrumSequence(trioDrumRef.current);
              // pd.start(trioDrumRef.current);
              // pd.stop();
              // playerDrums.current.getAudioNodeOutput().volume.value = drumVolume;
              // playerDrums.current.start(trioDrumRef.current);
              // playerDrums.current.stop();
            }
            // trioDrumRef.current.forEach(note => {
            //   var pitch = Tone.Frequency(note.pitch -21, "midi").toNote();;
            //   var start = note.quantizedStartStep / 8 * 1000;
            //   console.log("playing DRUM sequence pitch: " + pitch + " start: " + start);
            //   setTimeout(() => playerDrums.current.play(pitch), start);
            // });
          }
        }
        if (playTrioDrums && trioBassRef.current != null && trioBassRef.current.notes.length > 0) {
          // if (playTrioBass && trioBassRef.current != null && trioBassRef.current.notes.length > 0) {
          // play bass line
          console.log("trio bass*******:")
          console.log(trioBassRef.current.notes.length);
          playSequence(bassInstrument, trioBassRef.current.notes, 11);
        }
        //   if (AIOnanism) {
        //     if (Date.now() - lastHumanPlayed.current > 8000) {
        //       console.log("trio melody:")
        //       // console.log(trioMelRef.current.notes.length);
        //         // play melody if human hasn't been hitting
        //       //  playSequence(allInstruments[0], trioMelRef.current.notes, 0);
        //      }
        //   }
        // // if (AIOnanism && trioMelRef.current.length > 0) {
        //   // play bass line
        //   console.log("trio bass:")
        //   console.log(trioBassRef.current);
        //   playSequence(bassInstrument, trioBassRef.current);
        //   if (AIOnanism) {
        //     playSequence(allInstruments[0], trioMelRef.current);
        //   }
        // }
      }
    }, 8000);
    return () => clearInterval(interval);
    // }, []);
  }
    , [playTrioBass, playTrioDrums]);


  function playSFDrumSequence(sequence) {
    // var pd = new mm.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/sgm_plus');
    // pd.soundFont.initialize();
    // pd.loadSamples(trioDrumRef.current);
    sequence.notes.forEach(note => {
      var pitch = note.pitch; //Tone.Frequency(note.pitch, "midi").toNote();;
      // var start = note.quantizedStartStep / 8 * 1000;
      var start = note.startTime;
      console.log("playing sequence pitch: " + pitch + " start: " + start);
      setTimeout(() => {
        if (!playTrioDrumsRef.current) {
          return;
        }
        pdref.current.playNoteDown({ "pitch": pitch, "instrument": 2, "isDrum": true, "velocity": 127 })
        // setLastPlayedAnyInstrument(12);
        // setLastPlayedAny(pitch);
      }, start * 1000);
    });
  }

  function playDrumSequence(sequence) {
    sequence.forEach(note => {
      var pitch = Tone.Frequency(note.pitch, "midi").toNote();;
      var start = note.quantizedStartStep / 8 * 1000;
      console.log("playing sequence pitch: " + pitch + " start: " + start);
      setTimeout(() => {
        // if (!playTrioDrumsRef.current) {
        //   return;
        // }
        setLastPlayedAnyInstrument(12);
        setLastPlayedAny(pitch);
      }, start);
    });
  }


  function playSequence(instrument, sequence, num = 11) {
    sequence.forEach(note => {
      var pitch = Tone.Frequency(note.pitch, "midi").toNote();;
      var start = note.quantizedStartStep / 8 * 1000;
      console.log("playing sequence pitch: " + pitch + " start: " + start);
      setTimeout(() => {
        // setLastPlayed(timeTravelRef.current.lastPlayed);
        // timeTravel();
        // play(11,pitch);
        instrument.play(pitch);
        setLastPlayeds(pitch, num);
      }, start);
    });
  }

  // get all notes since now - duration and change start and end times
  function getLastNotes(notes, duration) {
    var cutoff = Date.now() - duration;
    var returnArray = [];
    for (var i = notes.length - 1; i >= 0; i--) {
      if (notes[i].startTime > cutoff) {
        var noteCopy = JSON.parse(JSON.stringify(notes[i]));
        noteCopy.startTime = (noteCopy.startTime - cutoff) / 1000;
        noteCopy.endTime = (noteCopy.endTime - cutoff) / 1000;
        if (noteCopy.endTime > 8) {
          noteCopy.endTime = 7.99;
        }
        noteCopy.pitch = Tone.Frequency(noteCopy.pitch).toMidi();
        returnArray.unshift(noteCopy);
      }
    }
    console.log("LASTNOTES:"); console.log(returnArray);
    return returnArray;
  }

  const nextTrio = () => {
    if (Date.now() - lastHumanPlayed.current > 28000) {
      // last_8_bars.length < 1 && ! AIOnanism) {
      trioDrumRef.current = null;
      trioBassRef.current = null;
      return;
      // don't run on empty
    }
    if (!playTrioDrums && !playTrioBass) {
      return;
    }
    log("next trio");
    //  log(notesForDrumifyRef.current);
    var duration = 8000;
    var last_8_bars = getLastNotes(notesForTrioRef.current, duration);
    console.log(last_8_bars);

    var start = Date.now();

    const DEFAULT_QUARTERS_PER_MINUTE = 120.0;
    var mmObject = { notes: last_8_bars, totalTime: 8 };
    const quantizedNotes = mm.sequences.quantizeNoteSequence(mmObject, 4);
    console.log(quantizedNotes);
    if (quantizedNotes.notes.length < 4 && trioDrumRef.current.notes.length < 3 && trioBassRef.current.notes.length < 3) {
      // sample
      trio_vae.sample(1).then((outputSequences) => {
        console.log("trio SAMPLE:")
        console.log(outputSequences);
        trioDrumRef.current = getInstrumentSequence(outputSequences[0], 2);
        trioBassRef.current = getInstrumentSequence(outputSequences[0], 1);
        trioMelRef.current = getInstrumentSequence(outputSequences[0], 0);
        var end = Date.now();
        var time = end - start;
        console.log("trio time:" + time);
        console.log("triobass:"); console.log(trioBassRef.current);
        return;
      })
    }

    // var allThreeNotes = [].concat(quantizedNotes.notes, trioDrumRef.current, trioBassRef.current);
    var allThreeNotes = [].concat(quantizedNotes.notes, trioDrumRef.current);// trioBassRef.current);
    quantizedNotes.notes = allThreeNotes;
    console.log("ALLTHREE");
    console.log(quantizedNotes);
    trio_vae.encode([quantizedNotes]).then((encoded_melody) => {
      console.log("ENCODED MELODY");
      console.log(encoded_melody);
      trio_vae.decode(encoded_melody, temperature).then((outputSequences) => {
        console.log("TRIO DECODE:")
        console.log(outputSequences);
        trioDrumRef.current = getInstrumentSequence(outputSequences[0], 2);
        trioBassRef.current = getInstrumentSequence(outputSequences[0], 1);
        trioMelRef.current = getInstrumentSequence(outputSequences[0], 0);
        var end = Date.now();
        var time = end - start;
        console.log("trio time:" + time);
        console.log("triobass:"); console.log(trioBassRef.current);
      }
      )
    })
  };

  function getDrumSequence(sequence) {
    var returnSequence = Object.assign({}, sequence);
    returnSequence.notes = [];
    console.log(sequence);
    sequence.notes.forEach(element => {
      if (element.isDrum == true) {
        returnSequence.notes.push(element);
      }
    });
    return returnSequence;

  }

  function getInstrumentSequence(outputSequences, instrumentNum) {
    var returnSequence = Object.assign({}, outputSequences);
    returnSequence.notes = [];
    console.log(outputSequences);
    outputSequences.notes.forEach(element => {
      if (element.instrument == instrumentNum) {
        returnSequence.notes.push(element);
      }
    });
    return returnSequence;

    // var returnSequence = [];
    // console.log("OS:");
    // console.log(outputSequences);
    // outputSequences.notes.forEach(element => {
    //   if (element.instrument == instrumentNum) {
    //     returnSequence.push(element);
    //   }
    // });
    // return returnSequence;
  }

  /**
   * playerDrums = new window.core.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/sgm_plus');
  playerDrums.start('{"tempos":[{"qpm":120}],"notes":[{"pitch":38,"velocity":28,"startTime":1.5008392346207984,"endTime":1.6258392346207984,"instrument":1,"isDrum":true},{"pitch":38,"velocity":29,"startTime":1.751692078774795,"endTime":1.876692078774795,"instrument":1,"isDrum":true},{"pitch":38,"velocity":22,"startTime":1.87559779494768,"endTime":2.00059779494768,"instrument":1,"isDrum":true},{"pitch":36,"velocity":57,"startTime":1.99580367654562,"endTime":2.12080367654562,"instrument":1,"isDrum":true},{"pitch":38,"velocity":18,"startTime":1.9986349075334147,"endTime":2.1236349075334147,"instrument":1,"isDrum":true},{"pitch":38,"velocity":0,"startTime":2.124107915966306,"endTime":2.249107915966306,"instrument":1,"isDrum":true},{"pitch":36,"velocity":24,"startTime":2.9982146226102486,"endTime":3.1232146226102486,"instrument":1,"isDrum":true},{"pitch":42,"velocity":12,"startTime":3.000469832739327,"endTime":3.125469832739327,"instrument":1,"isDrum":true},{"pitch":38,"velocity":45,"startTime":3.4998368343367474,"endTime":3.6248368343367474,"instrument":1,"isDrum":true},{"pitch":38,"velocity":14,"startTime":3.874200685415417,"endTime":3.999200685415417,"instrument":1,"isDrum":true}],"totalTime":4}/)
   */


  const playbackNote = (note) => {
    allInstruments[note.instrument].playGenieForceNote(note.note);
    setLastPlayeds(note.note, note.instrument, note.pitch, true);
    // simulateKey(instrumentKeyMap[note.instrument.toString() + note.pitch.toString()]);
  }

  const handleCloseWelcomeModal = () => setShowWelcomeModal(false);
  // const handleCloseGameModal = () => setShowGameModal(false);
  const handleCloseGameModal = () => document.getElementById("gamemodaldiv").style.zIndex = "-11";

  const handleCloseAboutModal = () => setShowAboutModal(false);
  const handleClose = () => setShowInstrumentModal(false);
  const handleClosePlayButtons = () => setShowPlayButtons(false);

  const edit = (instrumentNum) => {
    setCurrentInstrument(allInstruments[instrumentNum]);
    setShowInstrumentModal(true);
  };

  const editBass = () => {
    setCurrentInstrument(bassInstrument);
    setShowInstrumentModal(true);
  };

  const openPlayButtons = () => {
    setShowPlayButtons(true);
  };

  function setKeyAll(key) {
    setKeyOf(key);
    log("setkeyall: " + key);
    allInstruments.forEach((instrument) => {
      instrument.setKey(key);
    });
  }

  function setScaleAll(scale) {
    setScale(scale);
    allInstruments.forEach((instrument) => {
      instrument.setScale(scale);
    });
  }

  function setGamePreset(presetName) {
    log(gamePresets[presetName]);
    var preset = gamePresets[presetName];
    setInternalPreset(preset);
  }

  function setPreset(presetName) {
    log(allPresets[presetName]);
    var preset = allPresets[presetName];
    setInternalPreset(preset);
  }

  function setInternalPreset(preset) {
    setInstruments(preset.instruments);
    setmp3(preset.mp3);
    setScale(preset.instruments[0].scale);
    setKeyOf(preset.instruments[0].key);
    setBpm(preset.bpm);
    setQuant(preset.quant);
    log(presetName);
    setPresetName(presetName);
    setPlayerVolume(parseInt(preset.mp3Vol));
    setPlayTrioBass(preset.playTrioBass);
    setPlayTrioDrums(preset.playTrioDrums);
    setDrumVolume(parseInt(preset.drumVolume));
    setPlayRandomMovieSoundRegularly(preset.playRandomMovieSoundRegularly);
    setPlayRandomSoundRegularly(preset.playRandomSoundRegularly);
    setPlayRandomNatureSoundRegularly(preset.playRandomNatureSoundRegularly);
    setBassInstrument(preset.instrumentTrioBass);
    console.log("loaded preset:" + presetName);
  }

  function release(num, pitch) {
    if (!withRelease) {
      allInstruments[num].release(pitch);
    }
  }

  const playAsynch = (num, pitch = 0) => {
    console.log('playasynch');
    console.log(allInstruments[num].instrumentName);
    lastHumanPlayed.current = Date.now();
    if (quant == 'disabled') {
      play(num, pitch);
      return;
    }
    log("play asynch " + num + "\n" + pitch);
    var quantFloat = eval(quant);
    log("quant = " + quantFloat);
    var playPromise = allInstruments[num].playGenieAsync(pitch, withRelease, quantFloat, bpm);
    playPromise.then((note) => {
      log(`Received response: ${note}`);
      setLastPlayeds(note, num, pitch);
    });
  }

  function setLastPlayeds(note, instrumentNumber, pitch, playback = false) {
    var lastPlayedCopy = [...lastPlayed];
    lastPlayedCopy[instrumentNumber] = note;
    setLastPlayed(lastPlayedCopy);
    setLastPlayedAnyInstrument(instrumentNumber);
    setLastPlayedAny(note);
    setLastPlayedNote({ note: note, instrumentNumber: instrumentNumber, time: Date.now(), pitch: pitch, playback: playback });
  }

  function play(num, pitch = 0) {
    lastHumanPlayed.current = Date.now();
    log("play " + num + " pitch:" + pitch);
    var note = allInstruments[num].playGenie(pitch, withRelease);
    setLastPlayeds(note, num, pitch);
    // var midiNote = Tone.Frequency(note).toMidi();
    // if (useMidi) {
    //   sendMidiMessageOn(midiNote,num, 127);
    //   console.log("send midi on for " + note)
    //   var millisDuration = 2000;
    //   setTimeout(() => {console.log('off'); sendMidiMessageOff(midiNote,num, 127)}, millisDuration);
    // }
  }

  function _handleKeyDown(key) {
    if (key.repeat && !allowRepeat) {
      return;
    }
    log(key);
    switch (key.key) {
      case '/':
      case '/':
        playRandomSound();
        break;
      case 'd':
      case 'D':
        playAsynch(0, 0);
        break;
      case 'k':
      case 'K':
        playAsynch(1, 0);
        break;
      case 'c':
      case 'C':
        playAsynch(2, 0);
        break;
      case 'e':
      case 'E':
        playAsynch(3, 0);
        break;
      case 'f':
      case 'F':
        playAsynch(0, 1);
        break;
      case 'l':
      case 'L':
        playAsynch(1, 1);
        break;
      case 'v':
      case 'V':
        playAsynch(2, 1);
        break;
      case 'r':
      case 'R':
        playAsynch(3, 1);
        break;
      case 's':
      case 'S':
        playAsynch(0, -1);
        break;
      case 'j':
      case 'J':
        playAsynch(1, -1);
        break;
      case 'x':
      case 'X':
        playAsynch(2, -1);
        break;
      case 'w':
      case 'W':
        playAsynch(3, -1);
        break;
      case 'i':
      case 'I':
        playRandomSoundMovies();
        break;
      case 'o':
      case 'O':
        playRandomSound();
        break;
      case 'u':
      case 'U':
        playRandomSoundNature();
        break;
      case '-':
        setShowGameModal(true);
        break;

      case '[':
        setDrawerOpen(true);
        break;
      case ';':
        setShowWelcomeModal(true);
        break;
      case ']':
        setSettingsOpen(true);
        break;
      case '0':
        setShowGameModal(!showGameModal);
        break;
    }
  }

  function _handleKeyUp(key) {
    if (withRelease) {
      // already getting released automatically
      return;
    }
    log(key.key);
    switch (key.key) {
      case 'a':
      case 'A':
        release(0, 0);
        break;
      case 's':
      case 'S':
        release(1, 0);
        break;
      case 'd':
      case 'D':
        release(2, 0);
        break;
      case 'f':
      case 'F':
        release(3, 0);
        break;
      case 'q':
      case 'Q':
        release(0, 1);
        break;
      case 'w':
      case 'W':
        release(1, 1);
        break;
      case 'e':
      case 'E':
        release(2, 1);
        break;
      case 'r':
      case 'R':
        release(3, 1);
        break;
      case 'z':
      case 'Z':
        release(0, -1);
        break;
      case 'x':
      case 'X':
        release(1, -1);
        break;
      case 'c':
      case 'C':
        release(2, -1);
        break;
      case 'v':
      case 'V':
        release(3, -1);
        break;
    }
  }

  function toggleRandomizeFourth(event) {
    setRandomFourth(event.target.checked);
  }

  useEffect(() => {
    if (randomFourth) {
      randomizeFourth();
    }
  }, [randomFourth]);


  function randomizeFourth() {
    log("RAND CALLED");
    log(allInstruments);
    if (randomFourth) {
      var n = Math.floor(Math.random() * instArray.length);
      var inst = allInstruments[3];
      inst.setInstrumentName(instArray[n]);
      var instrumentsCopy = [...allInstruments];
      instrumentsCopy[3] = inst;
      setInstruments(instrumentsCopy);
      setTimeout(() => { randomizeFourth() }, 20000);
    }
  }

  useEffect(() => {
    if (connectMQTT) {
      mMQTTconnect();
    }
  }, [connectMQTT]);

  useEffect(() => {
    // setPreset('Lead');
  }, []);


  useEffect(() => {
    document.addEventListener("keydown", _handleKeyDown);
    return () => {
      document.removeEventListener("keydown", _handleKeyDown);
    };
  }, [_handleKeyDown]);

  useEffect(() => {
    document.addEventListener("keyup", _handleKeyUp);
    return () => {
      document.removeEventListener("keyup", _handleKeyUp);
    };
  }, [_handleKeyUp]);

  const enable = () => {
    setActivePlayButtons(true);
    log("ENABLE");
    playerRef.current.sync().start(0);
    Tone.Transport.start();
    console.log(playerRef.current);
    setLastAction({ action: "START_MP3", data: null, time: Date.now() })
    setPlayerStatus("PLAYING")
  };

  const playMp3 = () => {
    // playerRef.current.sync().start(0);
    // Tone.start();
    setLastAction({ action: "PLAY_MP3", data: '', time: Date.now() })
    Tone.Transport.start();
    log('transport started');
    setPlayerStatus("PLAYING")
  };

  const pause = () => {
    // drumifyStartTimeRef.current = Date.now();
    ////
    setLastAction({ action: "PAUSE_MP3", data: '', time: Date.now() })
    Tone.Transport.pause();
    setPlayerStatus("PAUSED")
  };

  function setmp3(mp3File, autostart = true) {
    Tone.Transport.stop();
    playerRef.current.stop();
    if (!playerRef.current._wasDisposed) {
      playerRef.current.dispose();
    }
    // playerRef.current.stop();
    log("setmp3: " + mp3File);
    if (mp3File == null) {
      set_mp3("");
      return;
    }
    set_mp3(mp3File);
    // const file = "https://0xdy3z.csb.app/mp3s/" + mp3File;
    const file = "/audio/" + mp3File;
    // const file = "/mp3s/" + mp3File;

    setLastAction({ action: "SET_MP3", data: mp3File, time: Date.now() })
    setActivePlayButtons(false);
    playerRef.current = new Tone.Player({
      url: file,
      loop: true,
      autostart: autostart,
      onload: () => {
        enable();
        // alert("-0");
      }
    }).toDestination();
    // var a = player.start(0);
    // var b = Tone.Transport.start();
  }

  var randomSounds = ["Beam Me Up Scotty.mp3", "Bike Horn.mp3", "Cicada.mp3", "Cow And Bell.mp3", "Dark Cavern Soundscape.mp3", "Good Bye Female.mp3", "Heartbeat.mp3", "Horn Honk.mp3", "Nature Ambiance.mp3", "Quack Quack.mp3", "Radio Tune.mp3", "Right Cross.mp3", "Shotgun_Blast.mp3", "Silly_Farts.mp3", "Siren.mp3", "Suspense.mp3", "Thunder Clap.mp3", "Totally Valley Girl.mp3", "Turkey_Call.mp3", "Wake Up Call.mp3", "Woodpecker Call.mp3", "Zen Temple Bell.mp3", "hawk_screeching.mp3", "shotgun-reload.mp3"];
  function playRandomSound() {
    var index = Math.floor(Math.random() * randomSounds.length);
    var soundName = randomSounds[index];
    var file = "/randomsounds/" + soundName;
    var player = new Tone.Player({
      url: file,
      autostart: true,
    }).toDestination();
  }

  var randomSoundsMovies = ["Aggression.mp3", "Apocalypse Now 1978  I love the smell of napalm.mp3", "Better.mp3", "Citizen Kane 1941  Rosebud.mp3", "E.T. the ExtraTerrestrial 1982  E.T. phone home.mp3", "Evil Laugh.mp3", "Friggin Bone.mp3", "Gone With the Wind 1939  I dont give a damn.mp3", "Good Bye.mp3", "Good Evening.mp3", "Jaws 1977   Bigger Boat.mp3", "No Place Like Home.mp3", "Phone is Ringing Dude.mp3", "The Godfather 1972  Offer.mp3", "The Godfather Part II 1974  Friends and Enemies.mp3", "The rum.mp3", "The Sixth Sense 1999  I see dead people.mp3", "The Terminator 1984  Hasta Lavista Baby.mp3", "The Terminator 1984  Ill be back.mp3", "toto.mp3"];
  function playRandomSoundMovies() {
    var index = Math.floor(Math.random() * randomSoundsMovies.length);
    var soundName = randomSoundsMovies[index];
    var file = "/randomsounds_movies/" + soundName;
    var player = new Tone.Player({
      url: file,
      autostart: true,
    }).toDestination();
  }

  var randomSoundsNature = ["big-rain-drops-2-6824.mp3", "birds_singing-6888.mp3", "birds-chirping-ambiance-26052.mp3", "cardinal-37075.mp3", "croworraven1-6749.mp3", "designed-fire-winds-swoosh-04-116788.mp3", "dog_barking-6296.mp3", "elephant-trumpets-growls-6047.mp3", "fire-sound-efftect-21991.mp3", "flying-mosquito-105770.mp3", "forest_cicada_loop-6031.mp3", "jump-into-water-splash-sound-6999.mp3", "monkey-scream-6407.mp3", "mooing-cow-122255.mp3", "owl_hooting_000102_0145s3-002-070-000-002-068-074-37397.mp3", "owl-hooting-48028.mp3", "rustling-leaves-6875.mp3", "seagull-14693.mp3", "sfx_submerge-14424.mp3", "single-horse-galopp-6152.mp3", "thunder-sound-45992.mp3", "underwater-waves-5983.mp3", "whining-dog-6110.mp3", "wolf-howl-6310.mp3"];
  function playRandomSoundNature() {
    bassifyOnServer();
    var index = Math.floor(Math.random() * randomSoundsNature.length);
    var soundName = randomSoundsNature[index];
    var file = "/randomsounds_nature/" + soundName;
    var player = new Tone.Player({
      url: file,
      autostart: true,
    }).toDestination();
  }

  function setPlayerVolume(e) {
    setMp3Vol(e);
    setLastAction({ action: "SET_PLAYER_VOLUME", data: e, time: Date.now() })
    playerRef.current.volume.value = e;
  }

  function logPreset() {
    var preset = new Preset('fromApp', allInstruments, mp3, allInstruments[0].scale, allInstruments[0].key);
    var presetJson = preset.toJson();
    log(presetJson);
    setPresetModalJson(presetJson);
    setShowPresetModal(true);

    // piano.draw();
  }

  function hidePresetModal() {
    setShowPresetModal(false);
  }

  function stop() {
    log("STOP");
    setLastAction({ action: "STOP_MP3", data: '', time: Date.now() })
    Tone.Transport.stop();
    setPlayerStatus("STOPPED")
  }
  function changeLog(event) {
    setShowLog(event.target.checked);
  }

  function changeMQTT(event) {
    setConnectMQTT(event.target.checked);
  }

  function changePlayRandomNatureSoundRegularly(event) {
    setPlayRandomNatureSoundRegularly(event.target.checked);
  }
  function changePlayRandomSoundRegularly(event) {
    setPlayRandomSoundRegularly(event.target.checked);
  }
  function changePlayRandomMovieSoundRegularly(event) {
    setPlayRandomMovieSoundRegularly(event.target.checked);
  }

  function changeUseMidi(event) {
    setUseMidi(event.target.checked);
  }

  function toolModalForward() {
    document.getElementById("tool").parentElement.style.zIndex = "22222";
    document.getElementById("overlay").parentElement.style.zIndex = "111111";
  }
  function toolModalBack() {
    document.getElementById("tool").parentElement.style.zIndex = "2";
    document.getElementById("overlay").parentElement.style.zIndex = "1";
  }

  function gameModalForward() {
    document.getElementById("gamemodal").parentElement.style.zIndex = "2222";
    document.getElementById("overlay").parentElement.style.zIndex = "111111";
  }

  function gameModalBack() {
    document.getElementById("gamemodal").parentElement.style.zIndex = "-1";
    document.getElementById("overlay").parentElement.style.zIndex = "1";
  }


  return (
    <div className="App">
      <Modal
        style={{ zIndex: '2' }}
        id='tool'
        className="modal-lg"
        show={true}
        onHide={toolModalBack}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Tool
          </Modal.Title>
        </Modal.Header>
        <ModalBody>

          <style type="text/css">
            {`
          .btn-p {
            background-color: purple;
            color: white;
          }
          .btn-y {
            background-color: yellow;
            color: white;
          }

          .btn-b {
            background-color: black;
            color: white;
          }
          .btn-r {
            background-color: red;
            color: white;
          }
          .btn-xxl {
            padding: 5rem 5rem;
            font-size: 5rem;
          }
        `}
          </style>
          {/* <Load loading={loading} toneInstruments={toneInstruments} setLoading={setLoading} genieRef={genieRef}>*/}
          <SideDrawer
            wtf={wtf}
            connectMQTT={connectMQTT}
            changeMQTT={changeMQTT}
            logPreset={logPreset}
            setBpm={setBpm}
            bpm={bpm}
            setQuant={setQuant}
            quant={quant}
            keyOf={keyOf}
            scale={scale}
            setKeyOf={setKeyAll}
            setScale={setScaleAll}
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            AIOnanism={AIOnanism}
            setAIOnanism={setAIOnanism}
            setDrumVolume={setDrumVolume}
            drumVolume={drumVolume}
            instrumentOptions={instArray}
            editBass={editBass}
            bassInstrument={bassInstrument}
            useMidi={useMidi}
            setUseMidi={setUseMidi}
            allowRepeat={allowRepeat}
            setAllowRepeat={setAllowRepeat}
            setWithRelease={setWithRelease}
            withRelease={withRelease}
            setConnectMQTT={setConnectMQTT}
            temperature={temperature}
            setTemperature={setTemperature}
            // playDrums={playDrums}
            playTrioDrums={playTrioDrums}
            setPlayTrioDrums={setPlayTrioDrums}
            playTrioBass={playTrioBass}
            setPlayTrioBass={setPlayTrioBass}
          ></SideDrawer>
          {/* <Drawer
        anchor='right'
        open={mobileOpen}
        onClose={hideDrawer}
      >
        fdsaf<br/>
        dsfsd
      </Drawer> */}


          <Container fluid>
            {/* className="d-grid gap-3"> */}
            <Piano
              lastPlayedNote={lastPlayedNote}
              prefix={'app'}
              keyOf={keyOf}
              scale={scale}
              style={{ paddingBottom: '33px' }}
              lastPlayedInstrument={lastPlayedInstrument}
              lastPlayedAny={lastPlayedAny}
            />
            {settingsOpen &&
              <ExpandLessIcon
                onClick={() => setSettingsOpen(!settingsOpen)}
                fontSize='large'
                style={{ float: 'left' }}
              />}
            {!settingsOpen &&
              <ExpandMoreIcon
                onClick={() => setSettingsOpen(!settingsOpen)}
                fontSize='large'
                style={{ float: 'left' }}
              />}

            {wtf > 20 ? <Info
              setShowGameModal={setShowGameModal}
              setSettingsOpen={setSettingsOpen}
              playbackNote={playbackNote}
              lastPlayedInstrument={lastPlayedInstrument}
              lastPlayedAny={lastPlayedAny}
              wtf={wtf}
              setWTF={setWTF}
              setShowAboutModal={setShowAboutModal}
            /> : null}

            <Row style={{ paddingTop: '22px' }}>
              <Onboarding
                wtf={wtf}
                setWTF={setWTF}
              />
              <Col style={(settingsOpen == false) ? { display: 'none' } : { display: 'block' }}>
                <center>
                  <MainPageInteract
                    wtf={wtf}
                    setPresetRotateDuration={setPresetRotateDuration}
                    presetRotateDuration={presetRotateDuration}
                    setRotatePresets={setRotatePresets}
                    rotatePresets={rotatePresets}
                    selected={presetName}
                    setPreset={setPreset}
                    presetArray={Object.keys(allPresets)}
                    mp3={mp3}
                    setmp3={setmp3}
                    mp3s={mp3s}
                    play={playMp3}
                    stop={stop}
                    pause={pause}
                    mp3Vol={mp3Vol}
                    active={activePlayButtons}
                    setPlayerVolume={setPlayerVolume}
                    editBass={editBass}
                    bassInstrument={bassInstrument}
                    setDrawerOpen={setDrawerOpen}
                    setDrumVolume={setDrumVolume}
                    drumVolume={drumVolume}
                    setPlayTrioDrums={setPlayTrioDrums}
                    playTrioDrums={playTrioDrums}
                    setPlayTrioBass={setPlayTrioBass}
                    playTrioBass={playTrioBass}
                  />
                </center>
              </Col>
            </Row>
            <hr />

            <div>
              {/* style={{ marginTop: `auto` }}> */}

              <Row>
                <Col id='key_scale'>
                  {wtf >= wtfKeys.indexOf("KEY_SCALE") && settingsOpen == true &&
                    <KeyOf
                      keyOf={keyOf}
                      scale={scale}
                      setKeyOf={setKeyAll}
                      setScale={setScaleAll}
                    />
                  }
                </Col>
                <Col>
                </Col>
                <Col id='bpm_quant'>
                  {wtf >= wtfKeys.indexOf("BPM_QUANT") && settingsOpen == true &&
                    <Quant
                      setBpm={setBpm}
                      bpm={bpm}
                      setQuant={setQuant}
                      quant={quant}
                    />
                  }
                </Col>
              </Row>
              <br />
              <Row>
                {/* <Stack spacing={2} justifyContent="space-evenly"  alignItems="center" direction="row"> */}
                <Col style={{ display: 'flex' }}>
                  <InstrumentButtons
                    edit={edit}
                    instrumentOptions={instArray}
                    instruments={allInstruments}
                    num={0}
                    wtf={wtf}
                    letterHigh={TbLetterF}
                    letter={TbLetterD}
                    letterLow={TbLetterS}
                    bgc={'cyan'}
                    release={release}
                    play={playAsynch}
                    color={'black'}
                    lastPlayed={lastPlayed}
                    randsound={false}
                  />
                </Col>
                <Col>
                  <div
                    id='second_instrument'
                    style={(wtf < wtfKeys.indexOf("TWO_INSTRUMENTS")) ? { display: 'none' } : { display: 'flex' }}>
                    <InstrumentButtons
                      edit={edit}
                      instrumentOptions={instArray}
                      instruments={allInstruments}
                      num={1}
                      wtf={wtf}
                      letterHigh={TbLetterL}
                      letter={TbLetterK}
                      letterLow={TbLetterJ}
                      release={release}
                      play={playAsynch}
                      bgc={'magenta'}
                      color={'black'}
                      lastPlayed={lastPlayed}
                      randsound={false}
                    />
                  </div>
                </Col>
                <Col>
                  <div
                    id='instrument2'
                    style={(wtf < wtfKeys.indexOf("ALL_INSTRUMENTS_AND_SOUNDS")) ? { display: 'none' } : { display: 'flex' }}>
                    <InstrumentButtons
                      style={(wtf < wtfKeys.indexOf("ALL_INSTRUMENTS_AND_SOUNDS")) ? { display: 'none' } : { display: 'flex' }}
                      edit={edit}
                      instrumentOptions={instArray}
                      instruments={allInstruments}
                      num={2}
                      wtf={wtf}
                      letterHigh={TbLetterR}
                      letter={TbLetterE}
                      letterLow={TbLetterW}
                      play={playAsynch}
                      bgc={'yellow'}
                      color={'black'}
                      release={release}
                      lastPlayed={lastPlayed}
                      randsound={false}
                    />
                  </div>
                </Col>
                <Col>
                  <div
                    id='sounds'
                    style={(wtf < wtfKeys.indexOf("ALL_INSTRUMENTS_AND_SOUNDS")) ? { display: 'none' } : { display: 'grid' }}
                  >

                    <FormControl dense sx={{ borderRadius: 1, border: 1, padding: '5px', borderColor: 'grey.600', "&:hover": { border: '2px solid', borderColor: 'black' } }}>
                      <FormLabel style={{ marginLeft: "0.71em", marginTop: "-0.71em", paddingLeft: "0.44em", zIndex: 2, backgroundColor: "white", position: "absolute", fontSize: "0.75em" }}>Sounds</FormLabel>

                      {/* <Box sx={{ border:2, borderRadius: '5px' ,borderColor: 'primary.main' }}>
            <FormLabel
        sx={{
          marginLeft: "0.71em",
          marginTop: "-0.71em",
          paddingLeft: "0.44em",
          paddingRight: '0.44em',
          zIndex: 999,
          position: "absolute",
          fontSize: "0.75em",
          width: 'auto',
        }}>SOUNDS</FormLabel> */}
                      <Grid sx={{ paddingTop: '12px' }}>
                        <span style={{ float: 'right' }}>
                          Ongoing
                        </span>
                        <br />

                        <Grid item xs={8}>
                          <Button
                            id='randomSoundNature'
                            data-for="nature" data-tip
                            style={{ color: 'black', backgroundColor: 'green', margin: '2px', width: '95px' }}
                            onClick={() => playRandomSoundNature()}
                          >
                            Nature&nbsp;
                            <Letter letter={TbLetterU} />
                          </Button>
                          <Tooltip title="Plays sounds at random intervals.">
                            <FormControlLabel
                              style={{ margin: '0px', float: 'right' }}
                              control={
                                <Switch
                                  checked={playRandomNatureSoundRegularly}
                                  onChange={changePlayRandomNatureSoundRegularly}
                                />}
                            />
                          </Tooltip>
                        </Grid>
                        <Grid item xs={8}>

                          <Button id='randomSound'
                            data-for="randomsound" data-tip='Rand sound from list'
                            style={
                              {
                                color: 'black', backgroundColor: 'green', margin: '2px', width: '95px'
                              }}
                            onClick={() => playRandomSound()}
                          >
                            Random&nbsp;
                            <Letter letter={TbLetterO} />
                          </Button>
                          <Tooltip title="Plays sounds at random intervals.">
                            <FormControlLabel
                              style={{ margin: '0px', float: 'right' }}
                              control={
                                <Switch
                                  checked={playRandomSoundRegularly}
                                  onChange={changePlayRandomSoundRegularly}
                                />}
                            />
                          </Tooltip>
                        </Grid>
                        <Grid item xs={8}>
                          <Button
                            data-for="globall" data-tip='qqq'
                            style={
                              { color: 'black', backgroundColor: 'green', margin: '2px', width: '95px' }}
                            onClick={() => playRandomSoundMovies()}
                          >
                            Movie&nbsp;
                            <Letter letter={TbLetterI} />
                          </Button>
                          <Tooltip title="Plays Movie sounds at random intervals.">
                            <FormControlLabel
                              style={{ margin: '0px', float: 'right' }}
                              control={
                                <Switch
                                  checked={playRandomMovieSoundRegularly}
                                  onChange={changePlayRandomMovieSoundRegularly}
                                />}
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </FormControl>
                    {/* </Box> */}

                    {/* </Col> */}
                    {/* <Col style={(wtf < 7) ? {display:'none'} : {display:'flex'}}>
            <InstrumentButtons
              edit={edit}
              instrumentOptions={instArray}
              instruments={allInstruments}
              num={3}
              wtf={wtf}
              letterHigh={TbLetterR}
              letter={TbLetterF}
              letterLow={TbLetterV}
              play={playAsynch}
              bgc={'black'}
              release={release}
              color={'white'}
              lastPlayed = {lastPlayed}
              randsound={true}
            />
          </Col> */}
                  </div>
                </Col>

                {/* </Stack> */}
              </Row>
              <br />
              <Row>
                <Recording
                  lastAction={lastAction}
                  small={false}
                  playbackNote={playbackNote}
                  lastPlayedInstrument={lastPlayedInstrument}
                  lastPlayedAny={lastPlayedAny}
                  lastPlayedNote={lastPlayedNote}
                  wtf={wtf}
                />
                <br /><br />

              </Row>
              <Row>
                <br /><br />
                <label>
                  <input
                    type="checkbox"
                    checked={connectMQTT}
                    onChange={changeMQTT}
                  />
                  &nbsp; Connect MQTT
                </label>

              </Row>
              <Row style={(!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? { display: 'block' } : { display: 'none' }}>
                <div class='container d-flex justify-content-center mt-100'>
                  <button type="button" class="btn btn-primary mx-auto" data-toggle="modal" data-target="#exampleModal">
                    Share on social media
                  </button>
                </div>



                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                  aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content col-12">
                      <div class="modal-header">
                        <h5 class="modal-title">Share</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="icon-container1 d-flex">
                          <div class="smd">
                            <i class="img-thumbnail fab fa-facebook-messenger fa-2x"
                              style={{ color: '#7bb32e', backgroundColor: '#daf1bc' }}></i>
                            <p>Messenger</p>
                          </div>
                          <div class="smd">
                            <i class="img-thumbnail fab fa-telegram fa-2x"
                              style={{ color: '#7bb32e', backgroundColor: '#daf1bc' }}></i>
                            <p>Telegram</p>
                          </div>
                          <div class="smd">
                            <i class="img-thumbnail fab fa-weixin fa-2x"
                              style={{ color: '#7bb32e', backgroundColor: '#daf1bc' }}></i>
                            <p>WeChat</p>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <label style={{ fontWeight: 600 }}>Page Link <span class="message"></span></label><br />
                        <div class="row">
                          <input class="col-10 ur" type="url" placeholder="https://www.arcardio.app/acodyseyy"
                            id="myInput" aria-describedby="inputGroup-sizing-default" style={{ height: '40px' }} />
                          <button class="cpy" onclick="myFunction()"><i class="far fa-clone"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Card>
                  <Card.Header
                    style={{ backgroundColor: 'black', color: 'white' }}
                  >
                    Dev Zone
                  </Card.Header>
                  <Card.Body>
                    {/* <label>
        <input
          type="checkbox"
          checked={props.showLog}
          onChange={props.changeLog}
        />
        &nbsp; Show Logs
      </label> */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={useMidi}
                          onChange={changeUseMidi}
                        />}
                      label="Use Midi"
                    />
                    <label>
                      <input
                        type="checkbox"
                        checked={connectMQTT}
                        onChange={changeMQTT}
                      />
                      &nbsp; Connect MQTT
                    </label>

                    <Button
                      onClick={() => logPreset()}>
                      Show json of current setup
                    </Button>

                  </Card.Body>
                </Card>

              </Row>
            </div>
          </Container>



          {showLog &&
            <textarea id='log_area'
              readonly
              value={logValue.current}
              style={(wtf < 6) ? { display: 'none' } :
                { overflowY: 'scroll', color: 'white', backgroundColor: 'black', margin: '2px', width: '100%', height: '500px' }}
            >


            </textarea>

          }
        </ModalBody>
      </Modal>

      <PlayButtons
        instruments={allInstruments}
        show={showPlayButtons}
        onHide={handleClosePlayButtons}
      />

      <WelcomeModal
        loadedRecording={loadedRecording}
        setLoadedRecording={setLoadedRecording}
        toolModalForward={toolModalForward}
        gameModalForward={gameModalForward}
        gameModalBack={gameModalBack}
        params={params}
        setShowAboutModal={setShowAboutModal}
        setWTF={setWTF}
        setLevelNum={setLevelNum}
        setJamming={setJamming}
        show={showWelcomeModal}
        onHide={handleCloseWelcomeModal}
        setShowGameModal={setShowGameModal}
      />

      <GameModal
        lastAction={lastAction}
        playbackNote={playbackNote}
        loadedRecording={loadedRecording}
        lastPlayedNote={lastPlayedNote}
        setChords={setChords}
        chords={chords}
        playTrioDrums={playTrioDrums}
        setPlayTrioDrums={setPlayTrioDrums}
        playerStatus={playerStatus}
        allowRepeat={allowRepeat}
        setLevelNum={setLevelNum}
        levelNum={levelNum}
        gameModalForward={gameModalForward}
        gameModalBack={gameModalBack}
        setPlayerVolume={setPlayerVolume}

        params={params}
        jamming={jamming}
        setJamming={setJamming}
        setBpm={setBpm}
        bpm={bpm}
        setQuant={setQuant}
        quant={quant}

        mp3={mp3}
        setmp3={setmp3}
        mp3s={mp3s}
        play={playMp3}
        stop={stop}
        pause={pause}
        mp3Vol={mp3Vol}
        active={activePlayButtons}

        lastPlayedInstrument={lastPlayedInstrument}
        lastPlayedAny={lastPlayedAny}
        setGamePreset={setGamePreset}
        instruments={allInstruments}
        keyOf={keyOf}
        scale={scale}
        setKeyOf={setKeyAll}
        setScale={setScaleAll}
        lastPlayed={lastPlayed}
        playAsynch={(a, b) => playAsynch(a, b)}
        show={showGameModal}
        setShowGameModal={setShowGameModal}
        setShowWelcomeModal={setShowWelcomeModal}
        onHide={handleCloseGameModal}
      />

      <AboutModal
        setWTF={setWTF}
        show={showAboutModal}
        onHide={handleCloseAboutModal}
      />

      <InstrumentModal
        instrument={currentInstrument}
        instruments={instArray}
        show={showInstrumentModal}
        onHide={handleClose}
      />

      <Modal className="modal-lg"
        show={showPresetModal} onHide={hidePresetModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            Current setup:
          </Modal.Title>
        </Modal.Header>
        <ModalBody>
          {presetModalJson}
        </ModalBody>
      </Modal>
      {/* </Load> */}
    </div>
  );
}
